export default "__VITE_ASSET__Dk2NZ1fw__"